module.exports = __webpack_public_path__ + "static/media/transgender.af0e919f.svg";